import { render, staticRenderFns } from "./AddCalendarInLine.vue?vue&type=template&id=a28717b2&scoped=true&"
import script from "./AddCalendarInLine.vue?vue&type=script&lang=js&"
export * from "./AddCalendarInLine.vue?vue&type=script&lang=js&"
import style0 from "./AddCalendarInLine.vue?vue&type=style&index=0&id=a28717b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28717b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
